import { FC } from 'react';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import { ConfirmationDialog } from '@/components/dialogs/generic/confirmation';

import useInregelenDialog from './useInregelenDialog';

type VerwijderenInregelenDialogProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
  details: WerklijnContextMenuDetails;
};

const VerwijderenInregelenDialog: FC<VerwijderenInregelenDialogProps> = ({ showDialog, handleOpenChange, details }) => {
  const { resetDialog, verwijderInregelen } = useInregelenDialog(details, handleOpenChange, false);

  return (
    <ConfirmationDialog
      hasCloseInHeader={true}
      showDialog={showDialog}
      handleOpenChange={handleOpenChange}
      onCancel={() => resetDialog(true)}
      onConfirm={() => verwijderInregelen(details)}
      confirmButtonType='destructive'
      cancelText='Annuleren'
      confirmText='Verwijder inregeling'
      title='Inregeling verwijderen'
      message='Weet je zeker dat je deze inregeling wilt verwijderen? Dit kan niet worden teruggedraaid.'
      testId='inregeling-verwijderen'
    />
  );
};
export default VerwijderenInregelenDialog;
